__turbopack_context__.v({
  "active": "dropdown-module-scss-module__RlDhnq__active",
  "bgLayer": "dropdown-module-scss-module__RlDhnq__bgLayer",
  "blocksBackgroundColor": "dropdown-module-scss-module__RlDhnq__blocksBackgroundColor",
  "blocksFontColor": "dropdown-module-scss-module__RlDhnq__blocksFontColor",
  "content": "dropdown-module-scss-module__RlDhnq__content",
  "dropDownDetails": "dropdown-module-scss-module__RlDhnq__dropDownDetails",
  "dropdown": "dropdown-module-scss-module__RlDhnq__dropdown",
  "dropdownArrow": "dropdown-module-scss-module__RlDhnq__dropdownArrow",
  "dropdownList": "dropdown-module-scss-module__RlDhnq__dropdownList",
  "dropdownListAbove": "dropdown-module-scss-module__RlDhnq__dropdownListAbove",
  "editNavigation": "dropdown-module-scss-module__RlDhnq__editNavigation",
  "group": "dropdown-module-scss-module__RlDhnq__group",
  "groupHeader": "dropdown-module-scss-module__RlDhnq__groupHeader",
  "groupLink": "dropdown-module-scss-module__RlDhnq__groupLink",
  "label": "dropdown-module-scss-module__RlDhnq__label",
  "morphDropdownWrapper": "dropdown-module-scss-module__RlDhnq__morphDropdownWrapper",
  "no-csstransitions": "dropdown-module-scss-module__RlDhnq__no-csstransitions",
  "popOutIcon": "dropdown-module-scss-module__RlDhnq__popOutIcon",
  "secondaryNavBackgroundColor": "dropdown-module-scss-module__RlDhnq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "dropdown-module-scss-module__RlDhnq__themeBackgroundColor",
  "themeFontColor": "dropdown-module-scss-module__RlDhnq__themeFontColor",
  "tile": "dropdown-module-scss-module__RlDhnq__tile",
  "tileIcon": "dropdown-module-scss-module__RlDhnq__tileIcon",
  "tileNote": "dropdown-module-scss-module__RlDhnq__tileNote",
  "tileText": "dropdown-module-scss-module__RlDhnq__tileText",
});
